import { cn } from '@/lib/cn';

export interface TabItem {
  id: string;
  label: string;
}

interface TabsProps {
  tabs: TabItem[];
  activeTab: string;
  onChange: (tabId: string) => void;
  className?: string;
}

/**
 * Underline-style tabs. Mobile: horizontal scroll. Desktop: full row.
 */
export function Tabs({ tabs, activeTab, onChange, className }: TabsProps) {
  return (
    <div className={cn('flex gap-1 overflow-x-auto border-b border-kw-border', className)} role="tablist">
      {tabs.map((tab) => {
        const isActive = tab.id === activeTab;
        return (
          <button
            key={tab.id}
            role="tab"
            aria-selected={isActive}
            onClick={() => {
              onChange(tab.id);
            }}
            className={cn(
              '-mb-px shrink-0 border-b-2 px-3 py-2.5 text-[14px] font-medium transition-colors',
              isActive
                ? 'border-kw-cerulean text-kw-cerulean'
                : 'border-transparent text-kw-muted hover:text-kw-shark',
            )}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
